<template>
	<c-dialog ref="dialog" title="字段配置" enable-flex width="420" mode="slide" mask-close @resolve="submitHandle">
		<field-config-list ref="fieldConfig" class="flex-grow flex-column" private></field-config-list>
	</c-dialog>
</template>

<script>
	import fieldConfigList from './field_config.vue'

	export default {
		name: 'fieldConfig',

		components: {
			fieldConfigList
		},

		props: {
			viewId: [Number, String],
			params: Function
		},

		methods: {
			open() {
				this.request({
					url: '/sys_user_view/field_list',
					data: Object.assign({
						view_id: this.viewId
					}, this.params ? this.params() : {}),
					loading: true,
					success: data => {
						this.$refs.fieldConfig.set(data.field_list);
						this.$refs.dialog.open();
					}
				});
			},

			submitHandle(stop, next) {
				stop();
				this.request({
					url: '/sys_user_view/edit_field',
					data: {
						view_id: this.viewId,
						dimension_id: this.params ? this.params().dimension_id || 0 : 0,
						field_list: this.$refs.fieldConfig.get()
					},
					loading: true,
					success: () => {
						next();
						this.$message({
							message: '提交成功'
						});
						this.$emit('resolve');
					}
				})
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>
